const storage = {
    not_configured: 'مزود التخزين غير مكون.',
    missing_parameter: 'معلمة مفقودة {{parameter}} لمزود التخزين.',
    upload_error: 'فشل في تحميل الملف إلى مزود التخزين.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
